<ng-container *ngIf="!isBank; else bankModal">
    <h2 mat-dialog-title>
        Do you want to
        <span style="color:{{ data.color }}">{{ data.message }}</span>
        transaction?
    </h2>
    <div *ngIf="!availableBalance && !isLoading" class="flex justify-center">
        <p>Balance data not available for {{ data.paymentSystem }}</p>
    </div>
    <div *ngIf="isLoading" class="flex justify-center">
        <p>Waiting for balance data for {{ data.paymentSystem }}</p>
    </div>
    <div class="flex justify-center text-lg" *ngIf="availableBalance">
        Available balance for {{ data.paymentSystem }} is {{ availableBalance }}
    </div>
    <mat-dialog-content class="mat-typography">
        <mat-form-field
            appearance="fill"
            class="selector-container"
            *ngIf="isUnique && data.color !== 'red'"
        >
            <mat-label>Select a wallet</mat-label>
            <mat-select [(value)]="selected">
                <mat-option value="None">None</mat-option>
                <mat-option
                    *ngFor="let element of uniquePaymentSystemData.valuesArray"
                    value="{{ element.value }}"
                    >{{ element.nameSpace }}</mat-option
                >
            </mat-select>
        </mat-form-field></mat-dialog-content
    >
    <mat-dialog-actions class="flex justify-between">
        <button
            mat-button
            (click)="start()"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            [disabled]="
                data.color !== 'red' &&
                ((selected == 'None' && isUnique) || !isAvailable)
            "
        >
            Yes
        </button>
        <button
            mat-button
            (click)="closeDialog()"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
            No
        </button>
    </mat-dialog-actions>
</ng-container>

<ng-template #bankModal>
    <div class="flex justify-between h-full">
        <div class="p-4 w-1/3">
            <ng-container *ngIf="selected === 'None'">
                <mat-form-field appearance="fill" class="w-[15rem]">
                    <mat-label>Select bank</mat-label>
                    <mat-select [(value)]="selected">
                        <mat-option
                            *ngFor="let bank of banks"
                            [value]="bank.name"
                            [disabled]="bank.bannedCountries.includes(bankCountry)"
                        >
                            <div class="flex justify-between">
                                <span>{{ bank.name }}</span>
                                <span class="text-green-500">{{
                                    bank.limit
                                }}</span>
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="selected !== 'None'">
                <div class="flex flex-col justify-between h-full w-[15rem]">
                    <div>
                        <h2 class="text-xl mb-1">Transaction Data</h2>
                        <ng-container *ngFor="let field of fieldsToDisplay">
                            <p
                                *ngIf="data.metadata[field.key]"
                                class="border-b border-gray-200 pb-0.5"
                            >
                                {{ field.label }}:
                                {{ data.metadata[field.key] }}
                            </p>
                        </ng-container>
                    </div>
                    <div class="flex mt-6 space-x-4">
                        <button
                            class="fuse-mat-button-large w-full md:w-auto md:flex-grow"
                            mat-flat-button
                            (click)="resetSelection()"
                        >
                            Back
                        </button>
                        <button
                            class="fuse-mat-button-large w-full md:w-auto md:flex-grow md:mr-2"
                            mat-flat-button
                            [color]="'primary'"
                            (click)="start()"
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="bg-gray-200 p-4">
            <h2 class="text-xl mb-1">
                <strong>{{ ibanValue }}</strong> last withdrawals
            </h2>
            <div class="bg-white p-4 overflow-auto max-h-[300px]">
                <table class="table-auto w-full mx-auto">
                    <thead>
                        <tr>
                            <th class="px-4 py-2">Date</th>
                            <th class="px-4 py-2">Amount</th>
                            <th class="px-4 py-2">Payment System</th>
                            <th class="px-4 py-2">Withdraw ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container
                            *ngFor="
                                let withdraw of lastWithdraws;
                                let i = index
                            "
                        >
                            <tr>
                                <td class="border px-4 py-2">
                                    {{
                                        withdraw.date
                                            | date : "dd/MM/yyyy HH:mm:ss"
                                    }}
                                </td>
                                <td class="border px-4 py-2">
                                    {{ withdraw.amount }}
                                </td>
                                <td class="border px-4 py-2">
                                    {{ withdraw.paymentSystem }}
                                </td>
                                <td class="border px-4 py-2">
                                    {{ withdraw.withdrawId }}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container
                            *ngFor="
                                let empty of [0, 1, 2, 3]
                                    | slice : lastWithdraws.length;
                                let i = index
                            "
                        >
                            <tr>
                                <td class="border px-4 py-2">-</td>
                                <td class="border px-4 py-2">-</td>
                                <td class="border px-4 py-2">-</td>
                                <td class="border px-4 py-2">-</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>